export interface IDocument {
  id:number
}
